import { Button } from "antd";

export default function Revision() {
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #FDEBDE", backgroundColor: "#FDEBDE80" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/revision.svg" alt="" />
        <Button htmlType="button" className="orange-btn btn-sm" type="primary">
          View request
        </Button>
      </div>
      <h5> Customer asked for revision </h5>
      <h6> The proposal requires revision. </h6>
    </div>
  );
}
